import { useWorkspace } from '@/contexts/WorkspaceContext'
import { getMemberDisplayName } from '@/utils/memberDisplayName'
import css from './TextEditorMention.module.css'

const TextEditorMention = ({ attributes, children, element }: any) => {
    const { members } = useWorkspace()
    const member = members.find((m: any) => m.userId === element.value)

    return (
        <span {...attributes} contentEditable={false} className={css.mention}>
            @{getMemberDisplayName(member) || element.value}
            {children}
        </span>
    )
}

export default TextEditorMention
